import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import {
  listarPlacasSuccess,
  listarPlacasError,
  guardarPlacaSuccess,
  guardarPlacaError,
  actualizarPlacaSuccess,
  actualizarPlacaError,
  PLACAS_LISTAR,
  GUARDAR_PLACA,
  ACTUALIZAR_PLACA,
} from './PlacasActions';
import PlacaApi from './PlacasApiClient';
import { ERROR } from 'config/general/Configuracion';
import { Observable, of } from 'rxjs';
import { apiTimeout } from 'config/general/Configuracion';
import { addMessage } from 'conten/mensajes/MessagesActions';
import axios from 'axios';
import { OK } from 'config/general/Configuracion';

export const listarPlacasEpic = (action$) =>
  action$.pipe(
    ofType(PLACAS_LISTAR),
    mergeMap((action) =>
      PlacaApi.listarPlacas(action.paginacion)
        .then((response) => listarPlacasSuccess(response.data))
        .catch((error) => listarPlacasError(error))
    )
  );

export const guardarPlacaEpic = (action$, state$) =>
  action$.pipe(
    ofType(GUARDAR_PLACA),
    mergeMap(
      (action) =>
        new Observable((obs) => {
          axios.defaults.timeout = apiTimeout;
          axios(PlacaApi.guardarPlaca(action.placa))
            .then((response) => {
              if (response.status === 200 || response.status === 201) {
                obs.next(guardarPlacaSuccess(response.data));
                obs.complete();
                action.onSuccess(OK, response.data);
              }
            })
            .catch((error) => {
              obs.next(guardarPlacaError(error));
              var mensajeError = "Hubo un problema: " + error.message;
              if (error && error.response && error.response.data) {
                mensajeError = error.response.data;
              }
              action.onSuccess(ERROR, mensajeError + "");
              obs.next(
                addMessage({ variant: "error", message: mensajeError + "" })
              );
              obs.complete();
            });
        })
    )
  );
export const actualizarPlacaEpic = (action$) =>
  action$.pipe(
    ofType(ACTUALIZAR_PLACA),
    mergeMap((action) =>
      PlacaApi.actualizarPlaca(action.placa)
        .then((response) => actualizarPlacaSuccess(response.data))
        .catch((error) => actualizarPlacaError(error))
    )
  );
